module.exports = __webpack_public_path__ + "img/playbutton26.d16b7531.png";